import React from 'react';
import {
  Card,
  CardContent,
  Box,
  Typography,
  Stack
} from '@mui/material';
import HighlightOffRoundedIcon from '@mui/icons-material/HighlightOffRounded';
import FacebookRoundedIcon from '@mui/icons-material/FacebookRounded';
import InstagramIcon from '@mui/icons-material/Instagram';
import { useParams } from 'react-router-dom';
import { useResponsive } from '../../../services/hooks';

export default function DocumentSigningDueDateExceeded() {
  const { annex_nr } = useParams();
  const isDesktop = useResponsive();

  return isDesktop ? (
    <Box sx={{ height: '100vh', width: '100vw', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Card sx={{ width: '450px' }}>
        <CardContent>
          <Stack justifyContent="center" alignItems="center" spacing={2}>
            <HighlightOffRoundedIcon color="error" sx={{ fontSize: '48px' }} />
            <Typography variant="h4" textAlign="center" whiteSpace="pre-line">
              {Number(annex_nr) ? 'Przekroczono czas na podpisanie aneksu' : 'Przekroczono czas na podpisanie umowy'}
            </Typography>
            <Stack flexDirection="row" gap={2}>
              <a style={{ height: '24px', color: '#4267B2' }} href="https://www.facebook.com/kalisz.sun.sport" target="_blank" rel="noopener noreferrer">
                <FacebookRoundedIcon />
              </a>
              <a style={{ height: '24px' }} href="https://www.instagram.com/sun_sport.pl/" target="_blank" rel="noopener noreferrer">
                <svg width={0} height={0}>
                  <radialGradient id="rg" r="150%" cx="30%" cy="107%">
                    <stop stopColor="#fdf497" offset="0" />
                    <stop stopColor="#fdf497" offset="0.05" />
                    <stop stopColor="#fd5949" offset="0.45" />
                    <stop stopColor="#d6249f" offset="0.6" />
                    <stop stopColor="#285AEB" offset="0.9" />
                  </radialGradient>
                </svg>
                <InstagramIcon sx={{ fill: 'url(#rg)' }}/>
              </a>
            </Stack>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  )
    : <Box sx={{ height: '90vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Stack justifyContent="center" alignItems="center" spacing={2}>
        <HighlightOffRoundedIcon color="error" sx={{ fontSize: '72px' }} />
        <Typography variant="h3" textAlign="center" whiteSpace="pre-line">
          {Number(annex_nr) ? 'Przekroczono czas na podpisanie aneksu' : 'Przekroczono czas na podpisanie umowy'}
        </Typography>
        <Stack flexDirection="row" gap={2}>
          <a style={{ height: '24px', color: '#4267B2' }} href="https://www.facebook.com/kalisz.sun.sport" target="_blank" rel="noopener noreferrer">
            <FacebookRoundedIcon sx={{ fontSize: '60px' }} />
          </a>
          <a style={{ height: '24px' }} href="https://www.instagram.com/sun_sport.pl/" target="_blank" rel="noopener noreferrer">
            <svg width={0} height={0}>
              <radialGradient id="rg" r="150%" cx="30%" cy="107%">
                <stop stopColor="#fdf497" offset="0" />
                <stop stopColor="#fdf497" offset="0.05" />
                <stop stopColor="#fd5949" offset="0.45" />
                <stop stopColor="#d6249f" offset="0.6" />
                <stop stopColor="#285AEB" offset="0.9" />
              </radialGradient>
            </svg>
            <InstagramIcon sx={{ fill: 'url(#rg)', fontSize: '60px' }}/>
          </a>
        </Stack>
      </Stack>
    </Box>;
}
